<template>
  <div>
    <NuxtLayout>
      <NuxtPage :transition="{ name: 'page', mode: 'out-in' }" />
    </NuxtLayout>
    <ClientOnly>
      <UNotifications />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
const { public: { appName } } = useRuntimeConfig();
useHead({
  title: appName,
  titleTemplate: (title) => title ? `${title} - ${appName}` : appName,
});

const { initTheme } = useTheme();
onMounted(async () => { await initTheme(); });
</script>
